"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subtractADayFromDate = exports.addADayToDate = exports.getMonthBoundaries = void 0;
const _1 = require(".");
const getMonthBoundaries = ({ year, month, timeZone, }) => ({
    startDate: new _1.DatePickerDate({
        type: 'Specific',
        year,
        month,
        day: 1,
    }).getAsDate(timeZone),
    endDate: new Date(new _1.DatePickerDate({
        type: 'Specific',
        year: month === 12 ? year + 1 : year,
        month: month === 12 ? 1 : month + 1,
        day: 1,
    })
        .getAsDate(timeZone)
        .getTime() - 1),
});
exports.getMonthBoundaries = getMonthBoundaries;
const addADayToDate = (date) => new Date(date.getTime() + _1.millisInADay);
exports.addADayToDate = addADayToDate;
const subtractADayFromDate = (date) => new Date(date.getTime() - _1.millisInADay);
exports.subtractADayFromDate = subtractADayFromDate;
//# sourceMappingURL=utils.js.map